import { IScenarioCase } from '../../interfaces/iscenario-case';
import { Case } from '../case';
import { Scenario } from '../scenario';

export class ScenarioCaseBase {
  ScenarioCaseId: number;
  ScenarioId: number | null;
  CaseId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Case?: Case;
  Scenario?: Scenario;

  constructor(item?: IScenarioCase) {
    if (item) {

      this.ScenarioCaseId = item.ScenarioCaseId;
      this.ScenarioId = item.ScenarioId;
      this.CaseId = item.CaseId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Case = new Case(item.Case);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}